/* The Homely Habit - overlay cart drawer. */
(function () {
  if (window.__hhDrawerInit) return;
  window.__hhDrawerInit = true;

  var root, itemsEl, countEl, subtotalEl, emptyEl, footerEl, recsEl, recsRowEl;
  var moneyFormat = '£{{amount}}';
  var rootUrl = '/';
  var busy = false;
  var lastCount = null;
  var polling = false;

  var ADD_EVENTS = ['shopify:cart:lines-update', 'cart:update', 'cart:refresh', 'cart:added'];
  var ADD_SELECTOR = 'button[name="add"], [type="submit"][name="add"], .product-form__submit, [data-hh-open-drawer]';

  function init() {
    root = document.getElementById('hh-drawer');
    if (!root) return false;
    moneyFormat = root.getAttribute('data-money-format') || moneyFormat;
    rootUrl = root.getAttribute('data-root-url') || '/';
    itemsEl = root.querySelector('[data-hh-items]');
    countEl = root.querySelector('[data-hh-count]');
    subtotalEl = root.querySelector('[data-hh-subtotal]');
    emptyEl = root.querySelector('[data-hh-empty]');
    footerEl = root.querySelector('[data-hh-footer]');
    recsEl = root.querySelector('[data-hh-recs]');
    recsRowEl = root.querySelector('[data-hh-recs-row]');
    return true;
  }

  function scroller() {
    return document.querySelector('.page-wrapper') || document.scrollingElement || document.body;
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function withCommas(n) {
    return n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }

  function formatMoney(cents) {
    var parts = (cents / 100).toFixed(2).split('.');
    var whole = parts[0];
    var dec = parts[1];
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount_no_decimals':
          return withCommas(String(Math.round(cents / 100)));
        case 'amount_with_comma_separator':
          return whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.') + ',' + dec;
        case 'amount_no_decimals_with_comma_separator':
          return String(Math.round(cents / 100)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
        case 'amount_with_space_separator':
          return whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ') + ',' + dec;
        case 'amount_no_decimals_with_space_separator':
          return String(Math.round(cents / 100)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
        case 'amount_with_apostrophe_separator':
          return whole.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1'") + '.' + dec;
        default:
          return withCommas(whole) + '.' + dec;
      }
    });
  }

  function sized(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function optionsHtml(item) {
    if (!item.options_with_values || !item.options_with_values.length) return '';
    var out = item.options_with_values
      .filter(function (o) {
        return o.value && o.value !== 'Default Title';
      })
      .map(function (o) {
        return '<p><strong>' + esc(o.name) + ':</strong> ' + esc(o.value) + '</p>';
      })
      .join('');
    return out ? '<div class="hh-dw__opts">' + out + '</div>' : '';
  }

  function itemHtml(item) {
    var img = item.image ? '<img src="' + esc(sized(item.image, 320)) + '" alt="">' : '';
    var was =
      item.original_line_price > item.final_line_price
        ? '<s class="hh-dw__was">' + formatMoney(item.original_line_price) + '</s>'
        : '';
    return (
      '<div class="hh-dw__item" data-key="' + esc(item.key) + '">' +
      '<a class="hh-dw__thumb" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="hh-dw__info">' +
      '<a class="hh-dw__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
      optionsHtml(item) +
      '<div class="hh-dw__line">' +
      '<div class="hh-dw__qty">' +
      '<button type="button" data-hh-step="-1" aria-label="Reduce quantity by one">−</button>' +
      '<span class="hh-dw__qty-value">' + item.quantity + '</span>' +
      '<button type="button" data-hh-step="1" aria-label="Increase quantity by one">+</button>' +
      '</div>' +
      '<div class="hh-dw__price">' + was + formatMoney(item.final_line_price) + '</div>' +
      '</div>' +
      '<button type="button" class="hh-dw__remove" data-hh-remove>Remove</button>' +
      '</div>' +
      '</div>'
    );
  }

  function updateBubbles(count) {
    document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function render(cart) {
    if (!root || !cart) return;
    lastCount = cart.item_count;
    var empty = !cart.items || cart.items.length === 0;
    root.classList.toggle('hh-drawer--empty', empty);
    if (countEl) countEl.textContent = cart.item_count;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (itemsEl) itemsEl.innerHTML = empty ? '' : cart.items.map(itemHtml).join('');
    if (emptyEl) emptyEl.hidden = !empty;
    if (footerEl) footerEl.hidden = empty;
    updateBubbles(cart.item_count);
    loadRecs(cart);
  }

  function recHtml(product) {
    var variant = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) {
        variant = product.variants[i];
        break;
      }
    }
    if (!variant) return '';
    var img = product.featured_image ? '<img src="' + esc(sized(product.featured_image, 160)) + '" alt="">' : '';
    return (
      '<div class="hh-dw__rec">' +
      '<a class="hh-dw__rec-media" href="' + esc(product.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<div class="hh-dw__rec-info">' +
      '<a class="hh-dw__rec-title" href="' + esc(product.url) + '">' + esc(product.title) + '</a>' +
      '<div class="hh-dw__rec-price">' + formatMoney(variant.price) + '</div>' +
      '</div>' +
      '<button type="button" class="hh-dw__rec-add" data-hh-add="' + variant.id + '">Add</button>' +
      '</div>'
    );
  }

  function loadRecs(cart) {
    if (!recsEl || !recsRowEl) return;
    if (!cart.items || !cart.items.length) {
      recsEl.hidden = true;
      return;
    }
    var productId = cart.items[0].product_id;
    var inCart = cart.items.map(function (i) {
      return i.product_id;
    });
    fetch(rootUrl + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=related', {
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var list = (data.products || [])
          .filter(function (p) {
            return inCart.indexOf(p.id) === -1;
          })
          .slice(0, 6);
        var html = list.map(recHtml).join('');
        if (!html) {
          recsEl.hidden = true;
          return;
        }
        recsRowEl.innerHTML = html;
        recsEl.hidden = false;
      })
      .catch(function () {
        recsEl.hidden = true;
      });
  }

  function getCart() {
    return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(
      function (r) {
        return r.json();
      }
    );
  }

  function lockScroll() {
    var el = scroller();
    if (el) {
      el.dataset.hhPrevOverflow = el.style.overflow || '';
      el.style.overflow = 'hidden';
    }
    document.body.classList.add('hh-drawer-open');
  }

  function unlockScroll() {
    var el = scroller();
    if (el) {
      el.style.overflow = el.dataset.hhPrevOverflow || '';
      delete el.dataset.hhPrevOverflow;
    }
    document.body.classList.remove('hh-drawer-open');
  }

  function isOpen() {
    return root && root.classList.contains('is-open');
  }

  function open() {
    if (!root || isOpen()) return;
    root.hidden = false;
    lockScroll();
    void root.offsetWidth;
    root.classList.add('is-open');
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-open');
    unlockScroll();
    window.setTimeout(function () {
      if (!isOpen()) root.hidden = true;
    }, 320);
  }

  function change(key, quantity) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch(rootUrl + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(render)
      .catch(function () {})
      .then(function () {
        busy = false;
        root.classList.remove('is-busy');
      });
  }

  function addVariant(variantId) {
    if (busy) return;
    busy = true;
    root.classList.add('is-busy');
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function () {
        return getCart();
      })
      .then(render)
      .catch(function () {})
      .then(function () {
        busy = false;
        root.classList.remove('is-busy');
      });
  }

  function refreshAndOpen() {
    getCart().then(function (cart) {
      render(cart);
      open();
    });
  }

  function pollForAdd() {
    if (polling) return;
    polling = true;
    var tries = 0;
    var baseline = lastCount;
    (function step() {
      tries += 1;
      getCart()
        .then(function (cart) {
          if (baseline === null || cart.item_count !== baseline) {
            polling = false;
            render(cart);
            open();
            return;
          }
          if (tries < 14) {
            window.setTimeout(step, 300);
          } else {
            polling = false;
          }
        })
        .catch(function () {
          polling = false;
        });
    })();
  }

  function bind() {
    root.addEventListener('click', function (event) {
      var target = event.target;
      if (target.closest('[data-hh-close]') || target.closest('[data-hh-overlay]')) {
        event.preventDefault();
        close();
        return;
      }
      var addBtn = target.closest('[data-hh-add]');
      if (addBtn) {
        event.preventDefault();
        addVariant(parseInt(addBtn.getAttribute('data-hh-add'), 10));
        return;
      }
      var item = target.closest('.hh-dw__item');
      if (!item) return;
      var step = target.closest('[data-hh-step]');
      var key = item.getAttribute('data-key');
      if (step) {
        event.preventDefault();
        var current = parseInt(item.querySelector('.hh-dw__qty-value').textContent, 10) || 0;
        change(key, Math.max(0, current + parseInt(step.getAttribute('data-hh-step'), 10)));
        return;
      }
      if (target.closest('[data-hh-remove]')) {
        event.preventDefault();
        change(key, 0);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) close();
    });

    document.addEventListener(
      'click',
      function (event) {
        var el = event.target.closest && event.target.closest(ADD_SELECTOR);
        if (!el || root.contains(el)) return;
        if (el.hasAttribute('data-hh-open-drawer')) {
          event.preventDefault();
          refreshAndOpen();
          return;
        }
        pollForAdd();
      },
      true
    );

    ADD_EVENTS.forEach(function (name) {
      document.addEventListener(name, function () {
        if (busy) return;
        refreshAndOpen();
      });
    });
  }

  function start() {
    if (!init()) return;
    bind();
    getCart().then(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
